export default {
  featuredExperiences: 'Naše doporučené zážitky',
  searchAllExperiences: 'Hledat všechny zážitky',
  searchAll: 'Hledat vše',
  groupSize: 'Velikost skupiny',
  eventSize: 'Velikost události',
  upTo: 'Až do',
  whatWeDo: 'Co budeme dělat',
  hostedBy: 'Pořádáno',
  whatsIncluded: 'Co je zahrnuto',
  avail: 'Dostupnost',
  whereWeAre: 'Kde budeme',
  experienceCalendar: 'Kalendář zážitků',
  experienceCancelled: 'Zážitek zrušen',
  experienceStartingPrice: 'Od {{price}}',
  experienceTotalPrice: 'Celkem {{price}}',
  at: 'v',
  viewPrivateSessAvailability: 'Zobrazit dostupnost soukromých sezení',
  selectSession: 'Vybrat sezení',
  sessionsCount: '{{count}} časů — vyberte čas',
  noAvailability: 'Není dostupné',
  select: 'Vybrat',
  slotLeft: '{{remainSlots}} slot zbývá',
  slotsLeft: '{{remainSlots}} slotů zbývá',
  spotsLeft: '{{count}} zbývá',
  spotsLeftAriaLabel: '{{count}} míst zbývá',
  bookExperience: 'Rezervovat zážitek',
  book: 'Rezervovat',
  learnMore: 'Zjistit více',
  apply: 'Aplikovat',
  maxPartySizes: 'Maximálně {{maxGroupSize}} slotů na skupinu',
  maxPartySize: 'Maximálně {{maxGroupSize}} slot na skupinu',
  selectSessionValidation: 'Prosím, vyberte sezení',
  selectParticipantValidation: 'Prosím, vyberte účastníky',
  selectDateValidation: 'Prosím, vyberte datum',
  reminders: 'Připomenutí',
  seeOtherDates: 'Zobrazit jiná data',
  location: 'Místo',
  about: 'O',
  allExperiences: 'Všechny zážitky',
  soldOut: 'Vyprodáno',
  reviews: 'Recenze',
  reviewSingular: 'recenze',
  reviewPlural: 'recenze',
  dateOfExperience: 'Datum zážitku',
  readLess: 'Číst méně',
  readMore: 'Číst více',
  seeMore: 'Vidět více',
  details: 'Detaily',
  durationHour: 'hodina',
  durationHours: 'hodiny',
  durationMinutes: 'min',
  theFollowingVideoDoesNotContainAnyAudio:
    'Následující video neobsahuje žádný zvuk',
  by: 'Od',
  chooseATime: 'Vyberte čas pro {{title}}',
  amenities: 'Vybavení',
  ticketSalesOpenIn: 'Prodej vstupenek začne za',
  ticketSalesOpen: 'Prodej vstupenek začíná',
  ticketSalesCloseIn: 'Prodej vstupenek končí za',
  ticketSalesClose: 'Prodej vstupenek končí',
  ticketSalesClosed: 'Prodej vstupenek byl ukončen',
  comingSoon: 'Již brzy',
  inPartnershipWith: 'Ve spolupráci s',
  notFoundExperienceTitle: 'Tento zážitek již není k dispozici',
  notFoundExperienceSubtitle: 'Mohl být odstraněn nebo odkaz již není platný.',
  deadLinkRecoverySubtitle: 'Objevte další zážitky, které si můžete rezervovat',
  viewAllExperiences: 'Zobrazit všechny zážitky',
  experienceBenefits: {
    benefits: {
      basePointsEarn:
        '<p><strong>Získejte 5 základních bodů</strong> za každý způsobilý utracený 1 USD, když se přihlásíte ke svému účtu World of Hyatt a zarezervujete si tento zážitek</p>',
      basePoints:
        '<p><strong>Získejte 10 základních bodů</strong> za každý způsobilý utracený 1 USD, když se přihlásíte ke svému účtu World of Hyatt a zarezervujete si tento zážitek</p>',
      additionalBonusPoints:
        '<p><strong>Získejte další 4 bonusové body</strong> za každý způsobilý utracený 1 USD, když zarezervujete s vaší kreditní kartou World of Hyatt</p>',
      additionalBonusPointsTier:
        '<p><strong>Získejte až o 30 % více bonusových bodů</strong> v závislosti na vašem úrovňovém statusu</p>',
      payWithPoints:
        '<p><strong>Plaťte pomocí bodů</strong> při rezervaci tohoto zážitku</p>',
    },
  },
};
